import React from "react";

function Data_Warehouse() {
  return (
    <div className="courseData">
      <div className="container">
        <div className="row">
          <div className="course_details_heading">
            <h1>CPP</h1>
            <br />
          </div>
          <div className="imgSection">
            <img src={require("../../../images/courses/C++.png")} alt="" />
          </div>
          <div className="heading">
            <h4 style={{ color: "blue" }}>DETAILS</h4>
            <ul>
              <li>
                On learning C Programming one can master C++ Programming
                language. C++ is an extension to C Programming and covers Object
                Oriented Programming popularly known as OOPS Concepts. C++ is a
                powerful general-purpose programming language. It can be used to
                create small programs or large applications. It can be used to
                make scripts or DOS programs. C++ allows you to create programs
                to do almost anything you need to do. The major difference
                between C and C++ is that C is procedural programming language
                and does not support classes and objects, while C++ is a
                combination of both procedural and objectoriented programming
                language;therefore C++ can be called a hybrid language.
              </li>
            </ul>

            <h4>Beginning with C++</h4>
            <ul>
              <li>What is C++, its Applications, Advantages etc </li>
              <li>
                Difference between C and C++. major and minor difference.{" "}
              </li>
              <li>
                Creating C++ source file, Editing, Compiling, Linking,
                Debugging. Etc.{" "}
              </li>
              <li>Make File Utility, Command Line Arguments etc. </li>
            </ul>

            <h4>
              Explaining Procedure oriented Language (C) and Object Oriented
              Language.(C++)
            </h4>
            <ul>
              <li> Look at Procedure-oriented Programming </li>
              <li> A Brief Look At Object Oriented Programming(OOP) </li>
              <li>Applications of OOP, Benefits of OOPS </li>
            </ul>

            <h4>C++ Tokens, Expressions, and Control Structure.</h4>
            <ul>
              <li> Tokens </li>
              <li> C++ keywords </li>
              <li> Basic Data Types </li>
              <li> User-defined Data Types </li>
              <li>Derived Data Types </li>
              <li> Operators in C++ </li>
              <li> Reference Variables </li>
              <li>Operator Precedence </li>
              <li>Control Structure </li>
            </ul>

            <h4>Functions In C++</h4>
            <ul>
              <li>Different forms of functions </li>
              <li>function prototyping </li>
              <li>Call by Reference </li>
              <li>Inline Functions </li>
              <li>Function overloading </li>
              <li>Operator Overloading </li>
              <li>friend and virtual functions</li>
            </ul>

            <h4>Classes And Objects</h4>
            <ul>
              <li>C Structure revision </li>
              <li>Defining classes, defining member functions </li>
              <li>Defining classes, defining member functions </li>
              <li>
                different forms of member functions dependence on access
                specifiers(i.e. Private, public, protected){" "}
              </li>
              <li>array of objects </li>
              <li>objects as function arguments </li>
              <li>returning objects </li>
              <li>pointers to members </li>
              <li>local classes. </li>
            </ul>

            <h4>Constructor and Destructor</h4>
            <ul>
              <li>introduction </li>
              <li>constructors </li>
              <li>Types of constructors </li>
              <li>Use of Multiple constructors </li>
              <li>dynamic initialization of objects</li>
              <li>Destructors</li>
            </ul>

            <h4>Operator Overloading and type conversion</h4>
            <ul>
              <li>Introduction</li>
              <li>defining operator overloading </li>
              <li>overloading overloading(unary, binary operators) </li>
              <li>overloading binary operators using friends </li>
              <li>Rules for overloading operators </li>
              <li>type conversion </li>
            </ul>

            <h4>Inheritance – extending class</h4>
            <ul>
              <li>Introduction </li>
              <li>Types of inheritance </li>
              <li>Single inheritance </li>
              <li>multiple inheritance</li>
              <li>Multilevel inheritance </li>
              <li>Hierarchical inheritance </li>
              <li>hybrid inheritance etc </li>
            </ul>

            <h4>Inheritance – extending class</h4>
            <ul>
              <li>Introduction </li>
              <li>pointers </li>
              <li>pointers to objects </li>
              <li>this pointer </li>
              <li>pointers to derived class </li>
              <li>virtual functions </li>
              <li>pure virtual functions etc.</li>
            </ul>

            <h4>Managing Console I/O Operations</h4>
            <ul>
              <li>Introduction </li>
              <li>C++ streams </li>
              <li>c++ stream classes </li>
              <li>unformated / formated I/O operations.</li>
              <li>managing output with manipulators </li>
            </ul>

            <h4>Working with files.</h4>
            <ul>
              <li>Introduction </li>
              <li>creating/ opening / closing / deleting files </li>
              <li>file pointers and their manipulators </li>
              <li>updating file random access to file </li>
              <li>Error handling during file operations. </li>
            </ul>

            <h4>Templates</h4>
            <ul>
              <li>Introduction </li>
              <li>class templates </li>
              <li>function templates </li>
            </ul>

            <h4>Exception Handling</h4>
            <ul>
              <li>Introduction </li>
              <li>
                Exception handling – throwing, catching, re-throwing an
                exceptions , specifying exceptions etc.{" "}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Data_Warehouse;
